import {
  AlertTriangle,
  BarChart3,
  Boxes,
  Building2,
  Car,
  ClipboardCheck,
  ClipboardList,
  Compass,
  Construction,
  DoorOpen,
  Download,
  Droplets,
  Eye,
  Fan,
  Flame,
  Gift,
  GitBranch,
  GraduationCap,
  Hammer,
  HardHat,
  LayoutGrid,
  Library,
  ListOrdered,
  MapPin,
  Network,
  Presentation,
  Radio,
  Route,
  ScanSearch,
  Search,
  Shield,
  Siren,
  SprayCan,
  Target,
  Thermometer,
  TrendingUp,
  Truck,
  Users,
  Waves,
  Wind,
  Wrench,
  type LucideIcon,
} from 'lucide-react'

export interface IncludedFeature {
  label: string
  icon: LucideIcon
  /** Headline features get a larger, highlighted card */
  featured?: boolean
}

export const everythingIncluded: IncludedFeature[] = [
  { label: '6 Complete Professional Volumes', icon: Library, featured: true },
  { label: 'Complete 6-in-1 Training System', icon: Boxes, featured: true },
  { label: '100% Visual Main Atlas', icon: Eye, featured: true },
  { label: 'Ready-to-Teach Training Resources', icon: Presentation, featured: true },
  { label: 'Firefighter Foundations', icon: Shield },
  { label: 'PPE and Protective Equipment', icon: HardHat },
  { label: 'SCBA Awareness', icon: Wind },
  { label: 'Firefighter Tools', icon: Wrench },
  { label: 'Equipment Identification', icon: ScanSearch },
  { label: 'Fire Apparatus Awareness', icon: Truck },
  { label: 'Hose Systems', icon: Waves },
  { label: 'Water Supply', icon: Droplets },
  { label: 'Nozzle References', icon: SprayCan },
  { label: 'Fireground Operations', icon: Flame },
  { label: 'Operational Organization', icon: Network },
  { label: 'Ladders', icon: Construction },
  { label: 'Forcible-Entry Awareness', icon: Hammer },
  { label: 'Building Access', icon: DoorOpen },
  { label: 'Ventilation Concepts', icon: Fan },
  { label: 'Structural Building Cutaways', icon: Building2 },
  { label: 'Search and Rescue', icon: Search },
  { label: 'Search Pattern Concepts', icon: Route },
  { label: 'Building Orientation', icon: Compass },
  { label: 'Victim-Location Awareness', icon: MapPin },
  { label: 'Rescue Priority Scenarios', icon: ListOrdered },
  { label: 'Fireground Hazard Awareness', icon: AlertTriangle },
  { label: 'Structural Fire Conditions', icon: Thermometer },
  { label: 'Communication Exercises', icon: Radio },
  { label: 'Firefighter Accountability', icon: ClipboardList },
  { label: 'Vehicle Rescue Awareness', icon: Car },
  { label: 'Technical Incident References', icon: Siren },
  { label: 'Equipment and Incident Diagrams', icon: LayoutGrid },
  { label: 'Instructor Drills', icon: Target },
  { label: 'Classroom Scenarios', icon: GraduationCap },
  { label: 'Decision-Making Exercises', icon: GitBranch },
  { label: 'Beginner-to-Advanced Adaptations', icon: BarChart3 },
  { label: 'Student Observation Tools', icon: Users },
  { label: 'Assessment Frameworks', icon: ClipboardCheck },
  { label: 'Training Progression Tools', icon: TrendingUp },
  { label: '5 Professional Instructor Bonuses', icon: Gift },
  { label: 'Immediate Digital Access', icon: Download },
]
